// Paragraphs are whatever the GM separated with a line break when typing a
// company description in the textarea - used to show just a short teaser on
// the Horowitzova banka overview (marketplace cards) while the full,
// multi-paragraph text is reserved for the company's own detail page.

export function splitParagraphs(text) {
  if (!text) return [];
  return text
    .split(/\n+/)
    .map((p) => p.trim())
    .filter(Boolean);
}

export function firstParagraph(text) {
  return splitParagraphs(text)[0] ?? "";
}
